module.exports = "/static/media/error_icon.7b3b7769.svg";